var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"crawler-web-app__window--min-size",attrs:{"id":"crawler-web-app"}},[_c('v-app',[_c('Header'),_c('v-main',{staticClass:"crawler-web-app__window--min-size"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }